// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5374":"6011b4e0","8440":"46f42eb6","9855":"9ac68d87","9874":"53d59af8"}[chunkId] + ".chunk.css";
};